import React from 'react';
import Grid from '@material-ui/core/Grid';

function ProgressIndicator() {
	const css = `
      :root {
        --animation-timing: 1.2s;
      }
      .glyph {
        fill: #89B4D6;
        animation: loading var(--animation-timing) infinite;
      }

      .glyph-1 {
        animation-delay: calc(var(--animation-timing) *0);
      }

      .glyph-2 {
        animation-delay: calc(var(--animation-timing) *.2);
      }

      .glyph-3 {
        animation-delay: calc(var(--animation-timing) *.3);
      }

      .glyph-4 {
        animation-delay: calc(var(--animation-timing) *.4);
      }

      .glyph-5 {
        animation-delay: calc(var(--animation-timing) *.5);
      }

      @keyframes loading {
        0% {
          fill: #5C93BF;
          transform: scale(1) translate(0, 0);
        }
        10% {
          fill: #89B4D6;
          transform: scale(1.02) translate(-1px, 0px);
        }
        100% {
          fill: #5C93BF;
          transform: scale(1) translate(0, 0);
        }
      }
      .background {
        fill: rgba(255,255,255,.8);
      }
    `;

	return (
		<>
			<Grid container style={{ justifyContent: "center" }} >
				<Grid>
					<span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 96 96"
							width="96px"
						>
							<style>{css}</style>
							<g fillRule="evenodd">
								<circle className="background" cx="48" cy="48" r="48"></circle>
								<path
									className="glyph glyph-5"
									d="M48.007 71.456L80 55.2 48.007 78.4 16 55.2z"
								/>
								<path
									className="glyph glyph-4"
									d="M48.007 56.36L80 49.6 48.007 64 16 49.6z"
								/>
								<path
									className="glyph glyph-3"
									d="M48.007 42.4L80 46.802 48.007 51.2 16 46.802 48.007 42.4"
								/>
								<path
									className="glyph glyph-2"
									d="M80 42.4L48.007 28 16 42.4l32.007-6.76z"
								/>
								<path
									className="glyph glyph-1"
									d="M80 39.2L48.007 16 16 39.2l32.007-16.256z"
								/>
							</g>
						</svg>
					</span>
				</Grid>
			</Grid>
		</>
	);
}

export default ProgressIndicator;
